import React from 'react';

import { SvgIcon } from '@material-ui/core';

const QRCodeIcon = (props) => (
  <SvgIcon {...props}>
    <path d="M3 11h8V3H3v8Zm2-6h4v4H5V5Zm-2 16h8v-8H3v8Zm2-6h4v4H5v-4ZM13 3v8h8V3h-8Zm6 6h-4V5h4v4Zm0 10h2v2h-2Zm-6-6h2v2h-2Zm2 2h2v2h-2Zm-2 2h2v2h-2Zm2 2h2v2h-2Zm2-2h2v2h-2Zm0-4h2v2h-2Zm2 2h2v2h-2Z" />
  </SvgIcon>
);

export default QRCodeIcon;
